import { hot } from 'react-hot-loader';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as S from '../store/selectors';

import './ScreenTerms.scss';



function ScreenTraits() {
  const traitsCount = useSelector(S.nft.getTraitsCount);
  const traits = useSelector(S.nft.getTraits);
  const traitsName = Object.keys(traits);
  return (
    <section className="section-terms">
      <div className="container" data-aos="fade-in" data-delay="200">
        <div className="pre-title">
          <Link className="pre-title-back" to="/">&larr; Go to homepage</Link>
        </div>

        <div className="row">
          <div className="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
            <h1 className="title">Roborovski NFT Traits</h1>
            <div className="textpage" style={{}}>
              <ul>
                {traitsName.map((item, index) => {
                  const names = Object.keys(traits[item]);
                  return (
                    <>
                      <li key={index}>
                        <span style={{ color: 'rgb(251, 189, 116)' }}>{item}</span>
                        <ul style={{ paddingLeft: '25px' }}>
                          {names.map((item2, index2) => {
                            return (
                              <li key={index2}>
                                <span style={{}}>{item2} </span>
                                <span style={{ fontSize: '1.3rem' }}>%{((traits[item][item2] / 7777) * 100).toFixed(2)}</span>
                              </li>
                            );
                          })}
                        </ul>
                      </li>
                    </>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default hot(module)(ScreenTraits);
